import * as actionTypes from './actionTypes';

export const loadClusterState = () => ({
  type: actionTypes.GET_CLUSTER_STATE
});

export const startCluster = () => ({
  type: actionTypes.CLUSTER_START
});

export const stopCluster = () => ({
  type: actionTypes.CLUSTER_STOP
});